import React from 'react';
import { Entity, EntityUser } from '@admiin-com/ds-graphql';
import { useCurrentUser } from '../useCurrentUser/useCurrentUser';

export const useClientFirmUsers = (client?: Entity | null) => {
  const user = useCurrentUser();
  const entityUsers = (client?.entityUsers?.items || []) as EntityUser[];

  const firmEntityUser = React.useMemo(
    () => entityUsers.find((item) => item?.userId === user?.id),
    [entityUsers, user?.id]
  );

  const partnerEntityUser = React.useMemo(
    () =>
      entityUsers.find((item) => item?.userId === firmEntityUser?.partnerId),
    [entityUsers, firmEntityUser?.partnerId]
  );

  const managerEntityUser = React.useMemo(
    () =>
      entityUsers.find((item) => item?.userId === firmEntityUser?.managerId),
    [entityUsers, firmEntityUser?.managerId]
  );

  return {
    firmEntityUser,
    partnerEntityUser,
    managerEntityUser,
    currentUser: user,
  };
};

export default useClientFirmUsers;
